import React, { Component } from 'react';

class BoldTextFormatter extends Component {
  render() {
    const { value } = this.props;
    return <span style={{ 'font-weight': 'bold' }}>{value || '-'}</span>;
  }
}

export default BoldTextFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/boldTextFormatter.jsx